import React from 'react';
import SelectField from './../Form/SelectField';

const FormP22T1 = React.memo((props) => {
    let clinicOptions = [{ value: '', label: 'Select option' }];
    for (let i = 0; i < props.clinics.length; i++) {
        clinicOptions.push({ value: props.clinics[i].id, label: props.clinics[i].name });
    }

    let selectedLocation = 'Select a Clinic';
    for (let i = 0; i < props.clinicLocations.length; i++) {
        if (parseInt(props.locationId) === parseInt(props.clinicLocations[i].id)) {
            selectedLocation = props.clinicLocations[i].name;
            break;
        }
    }

    if (props.fetchingClinicLocations) {
        selectedLocation = <div className="loading-locations"><i className="fas fa-circle-notch fa-spin" /></div>;
    }

    const handleChangeClinic = (value) => {
        props.setLocationId('');
        props.fetchClinicLocations(value);
        props.setClinicId(value);
        props.setQuantity('');

        props.checkAvailableItems(value, 'p22t1', props.language);
    }

    const handleChangeLanguage = (value) => {
        props.setLanguage(value);
        props.checkAvailableItems(props.clinicId, 'p22t1', value);
        props.setQuantity('');
    };

    let quantityOptions = [{ value: '', label: 'Select option' }];
    for (let i = 1; i <= 10; i++) {
        quantityOptions.push({ value: i, label: i });
    }

    let availableItemsContainer = null;
    if (props.availableItems != null) {
        availableItemsContainer = <div className="available-items-container">You have <strong>{props.availableItems}</strong> free item(s) available</div>;
    }

    return (
        <form action="" className="p22-container">
            <hr />
            <SelectField
                required
                label="Language"
                value={props.language}
                setFunction={handleChangeLanguage}
                options={[
                    { value: '', label: 'Select Option' },
                    { value: 'English', label: 'English' },
                    { value: 'Spanish', label: 'Spanish' },
                ]}
            />
            <hr />
            <h5 className="description-header">Shipping Information</h5>
            <SelectField
                required
                label="Clinic Name"
                value={props.clinicId}
                setFunction={handleChangeClinic}
                options={clinicOptions}
            />
            <div class="variable">
                <div class="label">Your Location:</div>
                <div className="location-address">{selectedLocation}</div>
            </div>
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={quantityOptions}
            />
            {availableItemsContainer}
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Travel Notice Vinyl Wall Cling</div>
                <div className="mt-2">
                    <span className="label">Description:</span>
                    <div>
                        This vinyl cling poster notifies patients to let their health care team know if they have
                        recently traveled internationally. The poster should be displayed in exam rooms or in lobbies. Available in English or Spanish.
                    </div>
                    <div className="mt-2">
                        The first 2 posters per language are FREE per clinic location, however clinics are responsible for the shipping charge.
                    </div>
                </div>
                <div className="description-list">
                    <span className="label">Details:</span>
                    <ul>
                        <li>8.5x11"</li>
                        <li>Full Color</li>
                        <li>Adhesive Vinyl - Peel and stick to a flat and clean surface</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP22T1;
